import { render, staticRenderFns } from "./FieldAlerts.vue?vue&type=template&id=4688ee6b&scoped=true&"
import script from "./FieldAlerts.vue?vue&type=script&lang=js&"
export * from "./FieldAlerts.vue?vue&type=script&lang=js&"
import style0 from "./FieldAlerts.vue?vue&type=style&index=0&id=4688ee6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688ee6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4688ee6b')) {
      api.createRecord('4688ee6b', component.options)
    } else {
      api.reload('4688ee6b', component.options)
    }
    module.hot.accept("./FieldAlerts.vue?vue&type=template&id=4688ee6b&scoped=true&", function () {
      api.rerender('4688ee6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldAlerts.vue"
export default component.exports